/**
 * @Description 选址地图详情分享页标题内容
 */

import { FC, useState } from 'react';
import { QuestionCircleOutlined } from '@ant-design/icons';
import cs from 'classnames';
import styles from './top.module.less';
import DataInfoModal from '@/common/components/business/AreaDetailDrawer/components/Top/DataInfoModal';
import LabelRow from './LabelRow';
import ReportLogo from '@/common/components/business/AreaDetailDrawer/components/ReportLogo';

interface TopProps {
  detail: any;
  overViewData: any;
  shareParams: any;
}
const Top: FC<TopProps> = ({
  detail,
  overViewData,
  shareParams,
}) => {
  const [openDataInfo, setOpenDataInfo] = useState(false); // 打开数据说明弹窗

  return (
    <>
      <div className={styles.topCon}>
        <div className={styles.titleCon}>
          <div className='fs-20 c-222 bold'>
            {detail?.areaName}
          </div>
          <LabelRow
            id={detail?.id}
            overViewData={overViewData}
            shareParams={shareParams}
          />
        </div>
        <div>
          <ReportLogo
            tenantId={shareParams.tenantId}
            tenantLogo={shareParams.reportLogo}
            className='pt-3 mb-16'
          />
          <div className={styles.targetOffset} onClick={() => {
            setOpenDataInfo(true);
          }}>
            <div className={cs('fs-12 c-666 mt-8 pointer', styles.descCon)}>
              <span className='pr-4'>数据说明</span>
              <QuestionCircleOutlined/>
            </div>
          </div>
        </div>
      </div>
      <DataInfoModal
        open={openDataInfo}
        setOpen={setOpenDataInfo}
        markType={overViewData?.markType}
        shareParams={shareParams}
      />
    </>

  );
};

export default Top;
